import styled from "styled-components";
import Button from "../../ui/Button";
import { EllipsisVerticalIcon } from "../../utils/icon.utils";
import { useGetAllCustomerQuery } from "../../utils/customer.utils";
import { arrayMap } from "../../utils/array.utils";

export default function CustomerFilter({ activeId = "", handleClick = () => {} }) {
  const { loading, data } = useGetAllCustomerQuery({
    query: ``,
    key: "CustomerForCustomerFilter"
  });

  const customers = data?.length ? data : [];

  return (
    <>
      <Button color="primary" icon={EllipsisVerticalIcon} data-bs-toggle="dropdown" />

      <ul className="dropdown-menu shadow border-0 mt-3 p-0">
        {loading && <DropdownItem>Loading...</DropdownItem>}
        <DropdownItem onClick={() => handleClick("")}>All</DropdownItem>
        {arrayMap(customers, (item) => (
          <DropdownItem
            onClick={() => handleClick(item?.id)}
            className={activeId === item?.id ? "active" : ""}
            key={item?.id}>
            {item?.name ?? ""}
          </DropdownItem>
        ))}
      </ul>
    </>
  );
}

const DropdownItem = styled.li`
  cursor: pointer;
  font-weight: 600;
  color: rgb(var(--default));
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
  padding: 0.3rem 0.5rem 0.3rem 0.5rem;
  &:hover {
    background-color: rgb(var(--primary));
    color: white;
  }
  &.active {
    background-color: rgb(var(--primary));
    color: white;
  }
`;
